import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { InfoStrip } from "@/components/site/InfoStrip";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Featured } from "@/components/site/Featured";
import { WhyUs } from "@/components/site/WhyUs";
import { Process } from "@/components/site/Process";
import { Team } from "@/components/site/Team";
import { Reviews } from "@/components/site/Reviews";
import { Appointment } from "@/components/site/Appointment";
import { WhatsAppCTA } from "@/components/site/WhatsAppCTA";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="grain min-h-screen bg-paper">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <InfoStrip />
                <About />
                <Services />
                <Featured />
                <WhyUs />
                <Process />
                <Team />
                <Reviews />
                <Appointment />
                <WhatsAppCTA />
                <Contact />
                <Faq />
                <FinalCTA />
            </main>
            <Footer />
            <Toaster position="bottom-center" />
        </div>
    );
}

export default App;
